import { styled as StyledMui } from "@mui/system";
import { Button } from "@mui/material";
import { laptopMQL } from "../../utils/constant";

export const SearchButton = StyledMui(Button)(() => ({
    fontSize: '2rem', 
    padding:'1rem 4.5rem', 
    width:'18rem',
    backgroundColor: '#CF2030', 
    color: '#FFFFFF',
    overflow: 'hidden',
    textOverflow:"ellipsis",
    "&:hover":{
        boxShadow: 'none !important',
        backgroundColor: '#CF2030 !important'
    },
    [laptopMQL]:{
            lineHeight: "normal"
    }
}));

